/**
 * Internal dependencies
 */
export type SaveRecipeFromRecipeDatalayerProps = {
	recipeName: string;
};

/**
 * Pushes an event to the data layer when a recipe is saved from another recipe in Keittokirja.
 * This is used for analytics tracking.
 * @param {SaveRecipeFromRecipeDatalayerProps} payload            - The payload containing recipe details.
 * @param {string}                             payload.recipeName - The name of the recipe saved.
 * @return {void}
 */
export function pushKeittokirjaSaveRecipeFromRecipe({
	recipeName,
}: SaveRecipeFromRecipeDatalayerProps): void {
	const isProduction = Boolean(window.valioAnalytics.isProduction);
	const datalayerObject = {
		event: 'keittokirja_save_recipe_from_recipe',
		recipe_name: recipeName,
	};

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(datalayerObject);

	if (!isProduction) {
		// eslint-disable-next-line no-console
		console.log('🔍 DataLayer: keittokirja_save_recipe_from_recipe', datalayerObject);
	}
}
